import { useRouter } from 'next/router'
import React from 'react'
import Header from 'src/components/auth/Header'
import { GenericLoader } from 'src/components/common/loader-components/GenericLoader'
import { AuthLayoutProps } from './types'

const AuthLayout = ({ children }: AuthLayoutProps) => {
  const router = useRouter()
  const { type } = router.query
  const redirectType = type ? type[0] : ''

  return (
    <>
      <div
        className={`flex  flex-col items-center  relative bg-[#101010] min-h-screen h-[100%] box-border ${
          redirectType === 'login' ? 'justify-center' : ''
        }`}
      >
        <Header />
        {children}
      </div>
      <GenericLoader />
    </>
  )
}

export default AuthLayout
